module.exports = __webpack_public_path__ + "media/images/workplace/intro-page/step1-1-p-3c812735ebbaf90d7af3d6186eca603e.gif";